import { postFellow, requestFellowHealth } from "./fellowClient";
import { getRealityCheckLatencies, saveRealityCheckLatency } from "./latencies/realityCheckLatencyStore";

const FELLOW_DEFAULT_BASE_URL = "https://backend2.bgbehavior.com";

function isRealityCheckEnabled() {
  const value = process.env.REACT_APP_FELLOW_REALITY_CHECK;
  return value == null ? true : value.toLowerCase() === "true";
}

function getFellowBaseUrl() {
  return (process.env.REACT_APP_FELLOW_BASE_URL || FELLOW_DEFAULT_BASE_URL).replace(/\/+$/, "");
}

function nowMs() {
  return typeof performance !== "undefined" && typeof performance.now === "function"
    ? performance.now()
    : Date.now();
}

function getLatencyHistory(records, metric) {
  return records
    .filter((record) => record?.metric === metric)
    .map((record) => ({
      timestamp: record?.timestamp || null,
      rtt_ms: typeof record?.rtt_ms === "number" ? record.rtt_ms : null,
      participant_id: record?.participant_id || null,
    }));
}

async function performFellowRealityCheck(participantID, startDate, { missionNumber = null, block = null, chat = false, buildBlock = false } = {}) {
  const existingLatencies = getRealityCheckLatencies();
  const existingHealthHistory = getLatencyHistory(existingLatencies, "health");
  const existingFellowHistory = getLatencyHistory(existingLatencies, "fellow");
  console.log("[RealityCheck] Historical health latencies before run:", existingHealthHistory);
  console.log("[RealityCheck] Historical fellow latencies before run:", existingFellowHistory);

  const baseUrl = getFellowBaseUrl();
  let healthRttMs = null;
  let fellowRttMs = null;

  try {
    const healthStartMs = nowMs();
    const healthResponse = await requestFellowHealth(baseUrl);
    healthRttMs = Math.round(nowMs() - healthStartMs);
    console.log("[RealityCheck] /health response:", healthResponse, "rtt_ms:", healthRttMs);
  } catch (error) {
    console.warn("[RealityCheck] /health request failed:", error);
  }

  try {
    const fellowStartMs = nowMs();
    const fellowPayload = {
      participant_id: participantID || "unknown",
      start_date: startDate,
      missionNumber,
      block,
      chat,
      build_block: buildBlock,
      source: "postFellow",
      event: "reality_check",
    };
    const fellowResponse = await postFellow(baseUrl, fellowPayload);
    fellowRttMs = Math.round(nowMs() - fellowStartMs);
    console.log(
      "[RealityCheck] /fellow response:",
      fellowResponse,
      "rtt_ms:",
      fellowRttMs
    );
  } catch (error) {
    console.warn("[RealityCheck] /fellow request failed:", error);
  }

  const timestamp = new Date().toISOString();
  const healthRecord = {
    timestamp,
    participant_id: participantID || "unknown",
    base_url: baseUrl,
    metric: "health",
    rtt_ms: healthRttMs,
  };
  const fellowRecord = {
    timestamp,
    participant_id: participantID || "unknown",
    base_url: baseUrl,
    metric: "fellow",
    rtt_ms: fellowRttMs,
    missionNumber,
    block,
  };

  saveRealityCheckLatency(healthRecord);
  saveRealityCheckLatency(fellowRecord);

  const updatedLatencies = getRealityCheckLatencies();
  const updatedHealthHistory = getLatencyHistory(updatedLatencies, "health");
  const updatedFellowHistory = getLatencyHistory(updatedLatencies, "fellow");
  console.log("[RealityCheck] Saved health latency record:", healthRecord);
  console.log("[RealityCheck] Saved fellow latency record:", fellowRecord);
  console.log("[RealityCheck] Historical health latencies after run:", updatedHealthHistory);
  console.log("[RealityCheck] Historical fellow latencies after run:", updatedFellowHistory);
}

export async function runFellowRealityChecks(participantID, startDate) {
  if (!isRealityCheckEnabled()) {
    console.log("[RealityCheck] Fellow checks disabled.");
    return;
  }

  await performFellowRealityCheck(participantID, startDate);
}
